<template>
  <div class="home xlbox" :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="负荷列表"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="tj historyDiares" :style="{ height: pageHeight-110 + 'px' }">
      <van-sticky :offset-top="46" v-show="!nodataShow">
        <ul>
          <li style="width:45.833%">时间</li>
          <li style="width:20.833%">A相(A)</li>
          <li style="width:16.666%">B相(A)</li>
          <li style="width:16.666%">C相(A)</li>
        </ul>
        <!-- <van-row>
          <van-col span="11">时间</van-col>
          <van-col span="5">A相(A)</van-col>
          <van-col span="4">B相(A)</van-col>
          <van-col span="4">C相(A)</van-col>
        </van-row> -->
      </van-sticky>
       <van-empty description="没有数据啦~" v-show="nodataShow"/>
      <ul class="van-cell-group" v-show="!nodataShow">
        <li class="van-cell" v-for="(item,index) in list" :key="index">
          <van-row>
            <van-col span="11">{{item.gpsTime? item.gpsTime:'/'}}</van-col>
            <van-col span="5">{{item.loadCur1!==null? item.loadCur1:'/'}}</van-col>
            <van-col span="4">{{item.loadCur2!==null? item.loadCur2:'/'}}</van-col>
            <van-col span="4">{{item.loadCur3!==null? item.loadCur3:'/'}}</van-col>
          </van-row>
        </li>
      </ul>

    </div>
    <van-pagination v-model="currentPage" :page-count="totalPage" mode="simple" @change="changePage" v-show="!nodataShow"/>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Col,
  Row,
  Cell,
  CellGroup,
  Button,
  Icon,
  NavBar,
  List,
  PullRefresh,
  DropdownMenu,
  DropdownItem,
  Sticky,
  Pagination,
  Empty
} from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(
  Col,
  Row,
  Cell,
  CellGroup,
  Button,
  Icon,
  NavBar,
  List,
  PullRefresh,
  DropdownMenu,
  DropdownItem,
  Sticky,
  Pagination,
  Empty
)

export default {
  name: 'FHListPage',
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Sticky.name]: Sticky,
    [Pagination.name]: Pagination,
    [Empty.name]: Empty
  },
  data () {
    return {
      nodataShow: false,
      pageHeight: window.innerHeight,
      mlineId: '', // 线路id
      elepoId: '',
      currentPage: 1, // 当前页
      pagesize: 20, // 每页显示条数
      totalPage: '', // 总页数
      list: []

    }
  },
  created () {
    // console.log('created')
    this.nodataShow = false
    this.mlineId = this.$route.query.mlineId // 传过来的线路id
    this.elepoId = this.$route.query.elepoId
    this.getList()
  },
  activated () {
    // console.log('activated')
    this.nodataShow = false
    // // 如果要在每次进入页面的时候获取最新的数据，需要在activated阶段获取数据，承担原来created钩子中获取数据的任务。
    this.mlineId = this.$route.query.mlineId // 传过来的线路id
    this.elepoId = this.$route.query.elepoId
    this.getList()
  },
  mounted () {
    // console.log('mounted')

  },
  methods: {
    onClickLeft () {
      // window.history.back()
      this.$router.go(-1) // 返回上一页面
    },
    changePage () {
      // 页码改变时触发
      // this.currentPage = currentPage
      this.getList()
    },
    getList () {
      this.util.post('/getFHList', {
        mlineId: this.mlineId, // 线路id
        elepoId: this.elepoId, // 杆塔id
        currentPage: this.currentPage, // 当前页
        pagesize: this.pagesize// 每页显示条数
      }).then(({ data }) => {
        if (data.code === 200) {
          // currentPage: 1, // 当前页
          // pagesize: 20, // 每页显示条数
          this.totalPage = data.data.totalPage// 总页数
          this.list = data.data.list
          if (this.list.length > 0) {
            this.nodataShow = false
          } else {
            this.nodataShow = true
          }
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    }

  },
  computed: {

  }
}
</script>

<style scoped lang="less">
/deep/.van-nav-bar{
  background: linear-gradient(227deg, #06C8B5 0%, #007CF8 100%);
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #fff;
}
/deep/.van-dropdown-menu__bar {
  width: 100vw;
  height: 34px;
  position: fixed;
  left: 0;
  top: 56px;
  z-index: 2;
}
/deep/.van-cell{
  line-height: 20px;
}
.home {
  background: #fff;
  overflow-y: hidden;
}
.tj{
  width: 100%;
  margin-top: 46px;
  margin-bottom: 10px;
  border-bottom: 1px solid #F9F9F9;
  overflow-y: auto;
}
.van-cell-group .van-cell:nth-child(even) {
  background: #f9f9f9;
}
.van-cell .van-row{
  width: 100%;
}
/deep/.van-sticky{
  background: #fff;
  padding: 10px 16px;
}
.tj .van-sticky--fixed ul{
  padding: 0px 12px;
}
.van-sticky li{
  display: inline-block;
  color: #A2A1A0;
  font-size: 13px;
  vertical-align: top;
}
</style>
